import React, { Fragment, useEffect, useState } from 'react';
import { Players } from './Players';
import { Helper } from '../common/helpers/Helper';
import { AppButton } from '../common/components/AppButton';
import { AppConfig } from '../AppConfig';
import { css, StyleSheet } from 'aphrodite';
import { Toast } from '../components/Toast';
const moment = require('moment');

export function PlayersLocations() {

  const [inProcess, setInProcess] = useState(false)
  const [deviceSearchErrMsg, setDeviceSearchErrMsg] = useState('');
  const [openErrorToast, setOpenErrorToast] = useState(false)

  const exportItems = {
    headers: {
      __index: 'index',
      deviceCode: 'deviceCode',
      title: 'deviceTitle',
      descr2: 'storeName',
      address: 'storeAddress',
    },
    format: 'xlsx'
  }

  const makeFileName = () => {
    return 'screens-dolphin-' + moment().format('MM-DD-YYYY_HH-mm-ss');
  }

  const prepExcelDownload = (items) => {
    const rows = [];

    for (const item of items) {
      const e = {};
      for (const hKey in exportItems.headers) {
        e[exportItems.headers[hKey]] = exportRowItemValue(hKey, item)
      }
      rows.push(e);
    }
    return rows
  }

  const exportRowItemValue = (key, current) => {
    switch (key) {
    case '__index':
      return current.__index + 1
    default:
      return current[key]
    }
  }

  const onExport = (items) => {
    if (items.length === 0) {
      showError(Helper.getString('selectVenuesToDownload'))
      return
    }
    const indexedItems = items.map((item, index) => ({ ...item, __index: index }));
    setInProcess(true)
    const DwnldUtil = require('../common/helpers/FileDownloader')

    const fileName = makeFileName();
    const rows = prepExcelDownload(indexedItems)
    DwnldUtil.FileDownloader.exportAsExcelFile(rows, fileName)
    setInProcess(false)
  }

  const showError = (errMsg) => {
    setDeviceSearchErrMsg(errMsg)
    setOpenErrorToast(true)
  }

  const renderDownloadButton = (selectedItems, screensItem, inProcess) => {
    const matchedItems = screensItem && screensItem.filter(item => selectedItems.includes(item.id));
    return (
      <div className={css(Styles.downloadButtonContainer)}>
        <div className={css(Styles.textAndButtonContainer)}>
          <div className={css(Styles.container)}>
            <span className={css(Styles.count)}>{selectedItems.length ? selectedItems.length + ' Screen(s)' : ''}</span>
            <AppButton
              buttonStyle={Styles.buttonStyle}
              buttonTextStyle={Styles.buttonTextStyle}
              inProcess={inProcess}
              onClick={() => { onExport(matchedItems) }}
              buttonText={Helper.getString('download')}
            />
          </div>
        </div>
      </div>
    )
  }

  const getErrorToast = () => {
    return (
      <Toast open={openErrorToast}
        severity='error'
        message={deviceSearchErrMsg}
        handleClose={handleErrorToastClose}
      />
    )
  }

  const handleErrorToastClose = (event, reason) => {
    setOpenErrorToast(false)
  };

  return (
    <Fragment>
      {getErrorToast()}
      <Players downloadButton={renderDownloadButton} mode='LOCATIONS' />
    </Fragment>
  )
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  downloadButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 767px)': {
      maxHeight: 'unset',
    },
    '@media (max-width: 1024px)': {
      padding: 20,
      position: 'fixed',
      backgroundColor: '#ffffff',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      bottom: 0,
      left: 0,
      right: 0
    }
  },
  textAndButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: 10,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      justifyContent: 'unset',
      alignItems: 'unset',
    }
  },
  buttonStyle: {
    minHeight: 54,
    minWidth: 180,
    padding: 16,
    backgroundColor: AppConfig.TINT_COLOUR,
    '@media (max-width: 767px)': {
      marginTop: 10,
      padding: 8
    }
  },
  buttonTextStyle: {
    fontSize: 16,
    fontWeight: 700,
    margin: 0,
    color: '#FFFFFF',
    '@media (max-width: 767px)': {
      fontSize: 16,
    }
  },
  count: {
    textAlign: 'right',
    fontSize: 24,
    fontWeight: 600,
    color: '#1B1B1B',
    margin: 0,
    marginBottom: 5,
    height: 35
  },
})


// WEBPACK FOOTER //
// ./src/screens/PlayersLocations.js